import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { unLocalizeNumbers, localizeNumbers } from "../../functions";
import CustomerApi from "../../api/customer";
import LineApi from "../../api/line";
import Cities from "./data/cities.json";
import Provinces from "./data/provinces.json";
import { useTranslation } from "react-i18next";
import AuthContext from "../auth-context";
import PhoneInfo from "../../types/phone-info";
import NgnLineSpecsApi from "../../api/ngn-line-specs";
import UserInfoApi from "../../api/user-info";
export interface ICustomerData {
  type: number;
  username: string;
  phone?: string;
  serviceType: string;
  agentCode: string;
  subCenterId: string;
  cityReferenceDataId: number | undefined;
}

export interface ICustomerInfoProps {
  type?: number;
  onSubmit: (customerData: ICustomerData) => void;
  authId?: string;
  handleAgentDataChange: (data: AgentData) => void;
}

interface AgentData {
  name: string | null;
  code: number | null;
  isSupportUser: boolean;
  hasSubAgents: boolean;
}

export interface ngnProvinces {
  [id: string]: string;
}

export default function CustomerInfo({
  type = 0,
  handleAgentDataChange,
  onSubmit,
}: ICustomerInfoProps) {
  const [birthDate, setBirthDate] = useState<DateObject | null>(null);
  const [selectedProvince, setSelectedProvince] = useState<string>();
  const [selectedCity, setSelectedCity] = useState<any>();
  const [selectedNgnProvince, setSelectedNgnProvince] = useState<number | null>(
    null
  );
  const [subCenter, setSelectedSubCenter] = useState<string>();
  const [phoneInfo, setphoneInfo] = useState<PhoneInfo | null>();
  const context = useContext(AuthContext);
  const [isCompany, setIsCompany] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const [checkBoxToggle, setcheckBoxToggle] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [apiResponse, setApiResponse] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [phoneError, setPhoneError] = useState<string | undefined>();
  const { t } = useTranslation(undefined, { keyPrefix: "SignUp.CustomerInfo" });
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [nationalCode, setNationalCode] = useState<string>("");
  const [nationalIdentity, setNationalIdentity] = useState<string>("");
  const [cellPhone, setCellPhone] = useState<string>("");
  let [ngnProvinces, setNgnProvinces] = useState<ngnProvinces>({});
  const [userData, setUserData] = useState<AgentData>({
    name: null,
    code: null,
    isSupportUser: false,
    hasSubAgents: false,
  });

  const maxDate = new DateObject({ calendar: persian }).subtract(18, "years");
  interface FormValues {
    phone?: string;
    isMale: boolean;
    firstName: string;
    lastName: string;
    nationalCode: string;
    fatherName: string;
    postalCode: string;
    provinces: string;
    city: string;
    byStreet: string;
    lastAlley: string;
    email?: string;
    cellPhone: string;
    type: 0 | 1 | 2;
    plaqueNo: string;
    unitNo: string;
    agentCode?: string;

    company?: {
      name: string;
      nationalIdentity: string;
    };
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onClickSetType = (type: number) => () => {
    if (type === 1) navigate("/signup/tdlte");
    else if (type === 3) navigate("/signup/fdlte");
    else if (type === 0) navigate("/signup/adsl");
    else navigate("/signup/ngn");
  };

  const handleName = (e: React.ChangeEvent<HTMLInputElement>) =>
    setFirstName(e.target.value);
  const handleLastName = (e: React.ChangeEvent<HTMLInputElement>) =>
    setLastName(e.target.value);
  const handleNationalCode = (e: React.ChangeEvent<HTMLInputElement>) =>
    setNationalCode(unLocalizeNumbers(e.target.value));
  const handleCellPhone = (e: React.ChangeEvent<HTMLInputElement>) =>
    setCellPhone(unLocalizeNumbers(e.target.value));
  const handleNationalIdentity = (e: React.ChangeEvent<HTMLInputElement>) =>
    setNationalIdentity(unLocalizeNumbers(e.target.value));

  const handleNgnProvince = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    const numericValue = value ? Number(value) : null;
    setSelectedNgnProvince(numericValue!);
    context.setNgnSelectedProvince(numericValue);
  };

  const handleSubCenter = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectedSubCenter(event.target.value);

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const validPhone = new RegExp("^0?[1-8][0-9]{9}$");
    const phone = unLocalizeNumbers(e.target.value);
    if (!validPhone.test(phone)) return;

    new LineApi(context)
      .get(phone)
      .then((data) => {
        setphoneInfo(data);
        if (data.errorMessage != null) {
          setApiResponse("error");
          setPhoneError(data.errorMessage);
          setcheckBoxToggle(true);
        } else {
          setApiResponse("success");
          setcheckBoxToggle(false);
        }
      })
      .catch();
  };

  const onFormSubmit = (formData: any) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    if (formData.phone) formData.phone = unLocalizeNumbers(formData.phone);
    formData.plaqueNo = unLocalizeNumbers(formData.plaqueNo);
    formData.unitNo = unLocalizeNumbers(formData.unitNo);
    formData.nationalCode = unLocalizeNumbers(formData.nationalCode);
    formData.cellPhone = unLocalizeNumbers(formData.cellPhone);
    formData.postalCode = unLocalizeNumbers(formData.postalCode);

    if (formData.company?.nationalIdentity)
      formData.company.nationalIdentity = unLocalizeNumbers(
        formData.company.nationalIdentity
      );

    var data = {
      ...formData,
      type,
      birthDate: +unLocalizeNumbers(birthDate!.format("YYYYMMDD")),
      serviceType: type === 2 ? "NGN" : type === 0 ? "ADSL" : "Td-Lte",
      subCenterId: subCenter,
      cityReferenceDataId: selectedCity,
    };

    if (!isCompany) delete data.company;

    context.setNgnSelectedProvince(selectedNgnProvince!);
    new CustomerApi()
      .post(data)
      .then((res) => {
        if (type !== 0) delete data.phone;
        if (!res.errorMessage)
          onSubmit({
            username: isCompany
              ? data.company?.nationalIdentity!
              : data.cellPhone!,
            phone: data.type !== 0 ? data.cellPhone : data.phone,
            type: +data.type!,
            serviceType: data.serviceType,
            agentCode: userData.code != null ? userData.code : data.agentCode,
            subCenterId: data.subCenterId!,
            cityReferenceDataId: data.cityReferenceDataId,
          });
        else setErrorMessage(res.errorMessage);
      })
      .catch(() => setErrorMessage("An error occurred during submission."))
      .finally(() => setIsSubmitting(false));
  };

  useEffect(() => {
    let agentApi = new UserInfoApi(context);
    agentApi.get().then((data) => {
      if (data) {
        console.log("userDatataaa:", data);

        setUserData({
          name: data.name,
          code: data.code,
          isSupportUser: data.isSupportUser,
          hasSubAgents: data.hasSubAgents,
        });
        handleAgentDataChange({
          name: data.name,
          code: data.code,
          isSupportUser: data.isSupportUser,
          hasSubAgents: data.hasSubAgents,
        });
      }
    });

    const productTypeApi = new NgnLineSpecsApi(context);
    productTypeApi.get(10).then((result) => {
      if (result?.specs?.[7]) {
        setNgnProvinces(result.specs[7].values);
      }
    });
    // eslint-disable-next-line
  }, []);
  return (
    <form onSubmit={handleSubmit(onFormSubmit)} className="signup-section">
      <div className="md:w-full lg:w-full xl:w-2/3 mx-auto xs:p-0  mt-10 p-10 rounded-xl">
        <>
          <h3 className="lead-title pt-2">{t("Service type")}</h3>
          <div className="w-full">
            <div className="mx-auto rtl pt-10 text-center flex  justify-center signup-user-type-section signup-tab-section flex-wrap md:flex-nowrap">
              <div className="flex items-center mr-4 tab-title-section">
                <h3 className="signup-form-ut-title">
                  {t("Choose your service")}
                </h3>
              </div>
              <div className="flex items-center mr-4">
                <input
                  type="radio"
                  {...register("type")}
                  value={1}
                  className="hidden"
                  checked={type === 1}
                  tabIndex={0}
                />
                <label
                  htmlFor="type"
                  className={
                    type === 1
                      ? "tab-active flex items-center cursor-pointer"
                      : "flex items-center cursor-pointer"
                  }
                  onClick={onClickSetType(1)}
                >
                  <div className="title">
                    <strong>{t("TD-LTE")}</strong>
                    <span className="w-4 h-4 inline-block mr-1 rounded-full border border-grey"></span>
                  </div>
                </label>
              </div>
              <div className="flex items-center mr-4">
                <input
                  type="radio"
                  {...register("type")}
                  value={0}
                  className="hidden"
                  checked={type === 0}
                />
                <label
                  htmlFor="type"
                  className={
                    type === 0
                      ? "tab-active flex items-center cursor-pointer"
                      : "flex items-center cursor-pointer"
                  }
                  onClick={onClickSetType(0)}
                >
                  <div className="title">
                    <strong>{t("ADSL")}</strong>
                    <span className="w-4 h-4 inline-block mr-1 rounded-full border border-grey"></span>
                  </div>
                </label>
              </div>
              <div className="flex items-center mr-4">
                <input
                  type="radio"
                  {...register("type")}
                  value={2}
                  className="hidden"
                  checked={type === 2}
                />
                <label
                  htmlFor="type"
                  className={
                    type === 2
                      ? "tab-active flex items-center cursor-pointer"
                      : "flex items-center cursor-pointer"
                  }
                  onClick={onClickSetType(2)}
                >
                  <div className="title">
                    <strong>{t("Ngn")}</strong>
                    <span className="w-4 h-4 inline-block mr-1 rounded-full border border-grey"></span>
                  </div>
                </label>
              </div>
              {userData.name != null && (
                <div className="flex items-center mr-4">
                  <input
                    type="radio"
                    {...register("type")}
                    value={1}
                    className="hidden"
                    checked={type === 1}
                    tabIndex={0}
                  />
                  <label
                    htmlFor="type"
                    className={
                      type === 3
                        ? "tab-active flex items-center cursor-pointer"
                        : "flex items-center cursor-pointer"
                    }
                    onClick={onClickSetType(3)}
                  >
                    <div className="title">
                      <strong>{t("FD-LTE")}</strong>
                      <span className="w-4 h-4 inline-block mr-1 rounded-full border border-grey"></span>
                    </div>
                  </label>
                </div>
              )}
            </div>
          </div>
        </>
        {type === 2 && (
          <div>
            <div className="company-section">
              <h3 className="lead-title">{t("NgnUsage Province")}</h3>
              <div className="form-section rtl flex flex-grow xs:flex-col sm:flex-row gap-4">
                <div className="flex flex-col xs:w-full sm:w-1/3 rtl text-right mt-6 relative">
                  <label htmlFor="" className="pr-4">
                    {t("Province")}
                  </label>
                  <select
                    value={selectedNgnProvince ?? ""}
                    className="mt-2"
                    tabIndex={13}
                    onChange={handleNgnProvince}
                  >
                    <option value="" disabled selected>
                      {t("choose your province")}
                    </option>
                    {Object.entries(ngnProvinces).map(([id, name]) => (
                      <option value={id} key={id}>
                        {name}
                      </option>
                    ))}
                  </select>
                  <p className="absolute left-0 text-red-500">
                    {errors.provinces?.message}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        {type === 0 ? (
          <div className="company-section">
            <h3 className="lead-title">{t("ADSL Phone number")}</h3>
            <div className="form-section rtl mt-2 flex flex-grow xs:flex-col lg:flex-row xl:flex-row gap-4">
              <div className="form-group flex flex-col xs:w-full sm:w-full lg:w-2/4  text-right  mt-6 relative">
                <label htmlFor="" className="pr-4">
                  {t("Phone number")}
                </label>
                <input
                  {...register("phone", {
                    required: "این فیلد الزامی است",
                    maxLength: { value: 11, message: "کمتر از 11 رقم" },
                  })}
                  type="tel"
                  name="phone"
                  className="text-ws-2 border-2 p-4 rounded-lg mt-2"
                  placeholder={t("enter your phone number")}
                  tabIndex={1}
                  onChange={handlePhoneChange}
                />
                <p className="absolute left-0 text-red-500">
                  {errors.phone?.message}
                </p>
              </div>
              {apiResponse === "error" ? (
                <p className="text-red-500">{phoneError}</p>
              ) : (
                type === 0 &&
                apiResponse === "success" && (
                  <div className="form-group flex flex-row flex-wrap justify-between xs:w-full sm:w-full lg:w-3/4  text-right  mt-6 relative">
                    <div className="xs:w-1/2">
                      <h5 className="pb-5">شهر :</h5>
                      <span>{phoneInfo?.city}</span>
                    </div>
                    <div className="xs:w-1/2">
                      <label className="pr-4">
                        {`مرکز مخابراتی ${phoneInfo?.center}`} :
                      </label>
                      {phoneInfo?.subCentersList?.length !== 0 ? (
                        <select
                          className="mt-2 xs:w-full"
                          onChange={handleSubCenter}
                        >
                          <option value="0">هیچکدام</option>
                          {phoneInfo?.subCentersList?.map(({ id, title }) => (
                            <option key={id} value={id}>
                              {title}
                            </option>
                          ))}
                        </select>
                      ) : null}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        ) : null}

        <div className="w-full">
          <div
            className="mx-auto rtl pt-10 text-center flex  justify-center signup-user-type-section flex-wrap md:flex-nowrap
           signup-tab-section"
          >
            <div className="flex items-center mr-4 tab-title-section">
              <h3 className="signup-form-ut-title">{t("User type")}</h3>
            </div>
            <div className="flex items-center mr-4">
              <input id="radio1" type="radio" name="radio" className="hidden" />
              <label
                htmlFor="radio1"
                className={
                  isCompany
                    ? "flex items-center cursor-pointer"
                    : "tab-active flex items-center cursor-pointer"
                }
                onClick={() => setIsCompany(false)}
              >
                <span className="sepanta-icon-user"></span>
                <div className="title">
                  <strong>{t("Person")}</strong>
                  <span className="w-4 h-4 inline-block mr-1 rounded-full border border-grey"></span>
                </div>
              </label>
            </div>
            <div className="flex items-center mr-4">
              <input
                id="radio2"
                type="radio"
                name="radio"
                className="hidden"
                checked
                tabIndex={2}
              />
              <label
                htmlFor="radio2"
                className={
                  isCompany
                    ? "tab-active flex items-center cursor-pointer"
                    : "flex items-center cursor-pointer"
                }
                onClick={() => setIsCompany(true)}
              >
                <span className="sepanta-icon-company"></span>
                <div className="title">
                  <strong>{t("Company")}</strong>
                  <span className="w-4 h-4 inline-block mr-1 rounded-full border border-grey"></span>
                </div>
              </label>
            </div>
          </div>
        </div>

        {isCompany ? (
          <div className="company-section mb-2">
            <h3 className="lead-title">{t("Company Info")}</h3>
            <div className="form-section rtl mt-2 flex flex-grow xs:flex-col lg:flex-row xl:flex-row gap-4">
              <div className="form-group flex flex-col sm:w-full lg:w-2/4  text-right  mt-6 relative">
                <label htmlFor="company.name" className="pr-4">
                  {t("Company name")} *
                </label>
                <input
                  {...register("company.name")}
                  className="border-2 p-4 rounded-lg mt-2"
                  placeholder={t("enter company name")}
                  tabIndex={3}
                />
                <p className="absolute left-0 text-red-500">
                  {errors.company?.name?.message}
                </p>
              </div>

              <div className="form-group flex flex-col  sm:w-full lg:w-2/4 rtl text-right  mt-6 relative">
                <label htmlFor="company.nationalIdentity" className="pr-4">
                  {t("Company national identity")} *
                </label>
                <input
                  {...register("company.nationalIdentity", {
                    required: t("required"),
                    pattern: {
                      value: /^[0-9]*$/,
                      message: t("national number is not valid"),
                    },
                    minLength: {
                      value: 11,
                      message: t("کمتر از 11 رقم"),
                    },
                    maxLength: {
                      value: 11,
                      message: "",
                    },
                  })}
                  type="tel"
                  maxLength={11}
                  className="border-2 p-4 rounded-lg mt-2"
                  placeholder={t("enter national identity of company")}
                  tabIndex={4}
                  onChange={handleNationalIdentity}
                />

                <p className="absolute left-0 text-red-500">
                  {errors.company?.nationalIdentity?.message}
                </p>
              </div>
            </div>
          </div>
        ) : null}

        <h3 className="lead-title pt-2">{t("Personal info")}</h3>
        <br />
        <ul className="text-red-500 text-right">
          <li>{errorMessage}</li>
        </ul>
        <div className="form-section rtl mt-2 flex flex-grow xs:flex-col lg:flex-row xl:flex-row gap-4">
          <div className="form-group flex flex-col xs:w-full sm:w-1/3 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("gender")} *
            </label>
            <select
              {...register("isMale", {
                required: t("required"),
              })}
              className="mt-2"
              tabIndex={13}
            >
              <option key="male" value="true">
                مرد
              </option>
              <option key="feMale" value="false">
                زن
              </option>
            </select>
            <p className="absolute left-0 text-red-500">
              {errors.provinces?.message}
            </p>
          </div>

          <div className="form-group flex flex-col sm:w-full lg:w-3/4 xl:w-2/4  text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("First name")}*
            </label>
            <input
              maxLength={20}
              {...register("firstName", {
                required: t("required"),
                maxLength: { value: 20, message: "" },
              })}
              type="text"
              name="firstName"
              className="border-2 p-4 rounded-lg mt-2"
              placeholder={t("enter your name")}
              tabIndex={5}
              onChange={handleName}
            />
            <p className="absolute left-0 text-red-500">
              {errors.firstName?.message}
            </p>
          </div>

          <div className="form-group flex flex-col sm:w-full lg:w-3/4 xl:w-2/4  text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Last name")}*
            </label>
            <input
              maxLength={30}
              tabIndex={6}
              {...register("lastName", {
                required: t("required"),
                maxLength: { value: 50, message: "بیشتر است" },
              })}
              type="text"
              name="lastName"
              className="border-2 p-4 rounded-lg mt-2"
              placeholder={t("enter your last name")}
              onChange={handleLastName}
            />
            <p className="absolute left-0 text-red-500">
              {errors.lastName?.message}
            </p>
          </div>
        </div>

        <div className="form-section rtl flex flex-grow xs:flex-col sm:flex-row gap-4">
          <div className="form-group flex flex-col  sm:w-full lg:w-2/4 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("National code")} *
            </label>
            <input
              maxLength={15}
              tabIndex={7}
              {...register("nationalCode", {
                required: t("required"),
                minLength: { value: 3, message: "کمتر از 3 رقم" },
                maxLength: { value: 15, message: "" },
              })}
              type="tel"
              className="border-2 p-4 rounded-lg mt-2"
              placeholder={t("enter your national code")}
              onChange={handleNationalCode}
            />
            <p className="absolute left-0 text-red-500">
              {errors.nationalCode?.message}
            </p>
          </div>

          <div className="form-group flex flex-col xs:w-full  sm:w-1/2 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Father name")} *
            </label>
            <input
              maxLength={20}
              tabIndex={8}
              {...register("fatherName", {
                required: t("required"),
              })}
              type="text"
              className="border-2 p-4 rounded-lg mt-2  tracking-wider text-right"
              placeholder={t("enter your father name")}
            />
            <p className="absolute left-0 text-red-500">
              {errors.fatherName?.message}
            </p>
          </div>
          <div className="form-group flex flex-col xs:w-full sm:w-1/2 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Birth date")} *
            </label>
            <div className="flex flex-row gap-2 mt-2">
              <DatePicker
                inputClass="full-size-dp"
                className="rmdp-mobile"
                render={<InputIcon tabIndex={9} />}
                calendar={persian}
                locale={persian_fa}
                maxDate={maxDate}
                value={birthDate}
                calendarPosition="bottom-right"
                onChange={(d) => {
                  if (Array.isArray(d)) d = d[0];
                  setBirthDate(d);
                }}
              />
              <input type={"hidden"} value={birthDate?.format()} />
            </div>
            <p className="absolute left-0 text-red-500">{t("required")}</p>
          </div>
        </div>

        <h3 className="lead-title pt-10">{t("Contact info")}</h3>

        <div className="form-section rtl flex flex-grow xs:flex-col sm:flex-row gap-4">
          <div className="form-group flex flex-col xs:w-full  sm:w-1/3 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Cell number")} *
            </label>
            <input
              tabIndex={10}
              {...register("cellPhone", {
                required: t("required"),
                minLength: { value: 11, message: "کمتر از 11 رقم" },
              })}
              type="tel"
              className="border-2 p-4 rounded-lg mt-2 text-right tracking-wider"
              placeholder={t("enter your cell number")}
              onChange={handleCellPhone}
            />
            <p className="absolute left-0 text-red-500">
              {errors.cellPhone?.message}
            </p>
          </div>
          <div className="form-group flex flex-col xs:w-full sm:w-1/3 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Email")}
            </label>
            <input
              maxLength={40}
              tabIndex={11}
              {...register("email", {
                maxLength: {
                  value: 40,
                  message: t("maximum 40 characters allowed"),
                },
                pattern: {
                  value: /^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})?$/i,
                  message: t("email is not valid"),
                },
              })}
              name="email"
              type="email"
              className={`border-2 p-4 rounded-lg mt-2 text-left tracking-wider ${
                errors.email ? "border-red-500" : ""
              }`}
              placeholder={t("enter your email")}
            />
            {errors.email && (
              <p className="absolute left-0 text-red-500">
                {errors.email.message}
              </p>
            )}
          </div>

          <div className="form-group flex flex-col xs:w-full sm:w-1/3 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Postal code")} *
            </label>
            <input
              tabIndex={12}
              maxLength={10}
              {...register("postalCode", {
                required: t("required"),
                maxLength: { value: 10, message: "کمتر از 10 رقم" },
              })}
              name="postalCode"
              className="border-2 p-4 rounded-lg mt-2 text-right tracking-wider"
              placeholder={t("enter your postal code")}
              type="tel"
            />
            <p className="absolute left-0 text-red-500">
              {errors.postalCode?.message}
            </p>
          </div>
        </div>

        <div className="form-section rtl flex flex-grow xs:flex-col sm:flex-row gap-4">
          <div className="form-group flex flex-col xs:w-full sm:w-1/3 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Province")} *
            </label>
            <select
              {...register("provinces", {
                required: t("required"),
              })}
              value={selectedProvince}
              className="mt-2"
              tabIndex={13}
              onChange={(e) => setSelectedProvince(e.target.value)}
            >
              <option value="" disabled selected>
                {t("choose your province")}
              </option>
              {Provinces.map(({ name, id }) => (
                <option value={id} key={id}>
                  {name}
                </option>
              ))}
            </select>
            <p className="absolute left-0 text-red-500">
              {errors.provinces?.message}
            </p>
          </div>

          <div className="form-group flex flex-col xs:w-full sm:w-1/3 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("City")} *
            </label>
            <select
              tabIndex={14}
              className="mt-2"
              {...register("city", {
                required: t("required"),
                maxLength: { value: 50, message: "" },
              })}
              onChange={(e) => setSelectedCity(e.target.value)}
            >
              <option value="" disabled selected>
                {t("choose your city")}
              </option>
              {Cities.map(({ id, name, provinceId }) =>
                selectedProvince === `${provinceId}` ? (
                  <option value={id} key={id}>
                    {name}
                  </option>
                ) : (
                  ""
                )
              )}
            </select>
            <p className="absolute left-0 text-red-500">
              {errors.city?.message}
            </p>
          </div>

          <div className="form-group flex flex-col xs:w-full sm:w-1/3 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Street")} *
            </label>
            <input
              maxLength={50}
              {...register("byStreet", {
                required: t("required"),
                maxLength: { value: 50, message: "" },
              })}
              type="address"
              className="border-2 p-4 rounded-lg mt-2 text-right tracking-wider"
              tabIndex={15}
              placeholder={t("enter your street")}
            />
            <p className="absolute left-0 text-red-500">
              {errors.byStreet?.message}
            </p>
          </div>
        </div>

        <div className="form-section rtl flex flex-grow flex-wrap  sm:flex-row mb-10 address-fields-section 2xl:flex-nowrap 2xl:gap-4">
          <div className="form-group flex flex-col  w-full xs:w-1/2 md:w-1/3 xl:w-1/3 2xl:w-1/4 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Last alley")} *
            </label>
            <input
              tabIndex={16}
              maxLength={50}
              {...register("lastAlley", {
                required: t("required"),
                maxLength: { value: 50, message: "" },
              })}
              type="address"
              className="border-2 p-4 rounded-lg mt-2 text-right tracking-wider"
              placeholder={t("enter your last alley")}
            />
            <p className="absolute left-0 text-red-500">
              {errors.byStreet?.message}
            </p>
          </div>
          <div className="form-group flex flex-col w-full xs:w-1/2 md:w-1/3 xl:w-1/3 2xl:w-1/4 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Plaque")}*
            </label>
            <input
              tabIndex={17}
              maxLength={10}
              {...register("plaqueNo", {
                required: t("required"),
              })}
              type="address"
              className="border-2 p-4 rounded-lg mt-2 text-right tracking-wider"
              placeholder={t("enter your plaque")}
            />
            <p className="absolute left-0 text-red-500">
              {errors.plaqueNo?.message}
            </p>
          </div>
          <div className="form-group flex flex-col  w-full xs:w-1/2 md:w-1/3 xl:w-1/3 2xl:w-1/4 rtl text-right  mt-6 relative">
            <label htmlFor="" className="pr-4">
              {t("Unit NO")}*
            </label>
            <input
              tabIndex={18}
              maxLength={10}
              {...register("unitNo", {
                required: t("required"),
              })}
              type="address"
              className="border-2 p-4 rounded-lg mt-2 text-right tracking-wider"
              placeholder={t("enter your unit NO")}
            />
            <p className="absolute left-0 text-red-500">
              {errors.unitNo?.message}
            </p>
          </div>
          {userData.code == null && userData.hasSubAgents && (
            <div className="form-group flex flex-col  w-full xs:w-1/2 md:w-1/3 xl:w-1/3 2xl:w-1/4 rtl text-right  mt-6 relative">
              <label htmlFor="" className="pr-4">
                {t("AgentCode")}
              </label>
              <input
                tabIndex={18}
                maxLength={10}
                {...register("agentCode")}
                type="address"
                className="border-2 p-4 rounded-lg mt-2 text-right tracking-wider"
                placeholder={t("enter your agentCopde")}
              />
              <p className="absolute left-0 text-red-500">
                {errors.agentCode?.message}
              </p>
            </div>
          )}
        </div>

        <div className="form-section rtl flex flex-grow xs:flex-col sm:flex-row  gap-4 justify-between">
          <div className="rule-section flex algin-center items-center gap-2">
            <input
              id="role-checkbox"
              type="checkbox"
              tabIndex={19}
              disabled={checkBoxToggle}
              onClick={() => setToggle(!toggle)}
            />
            <label className="role-checkbox-label" htmlFor="role-checkbox">
              <p className="w-50">
                {t("I had read and accept the contract", {
                  name: `${firstName ?? ""} ${lastName ?? ""}`,
                  nationalCode: localizeNumbers(nationalCode),
                  service:
                    type === 2
                      ? "NGN"
                      : type === 0
                      ? "ADSL"
                      : type === 3
                      ? "FD-LTE"
                      : "Td-Lte",

                  username: isCompany
                    ? localizeNumbers(nationalIdentity)
                    : localizeNumbers(cellPhone),
                })}
                <small>
                  <Link to="/signin" className="btn-show-role font-bold">
                    ({t("Read contract")})
                  </Link>
                </small>
              </p>
            </label>
          </div>
        </div>
        <div className="rule-section flex algin-center items-center gap-2">
          <button
            type="submit"
            disabled={toggle || isSubmitting}
            className={`signup-btn p-5 flex items-center justify-center gap-2 rounded-md ${
              isSubmitting
                ? "opacity-50 cursor-not-allowed"
                : "bg-blue-500 text-white"
            }`}
          >
            {isSubmitting ? (
              <>
                <div className="text-center w-100 py-5">
                  <div className="w-16 h-16 border-4 border-solid border-t-4 rounded-full animate-spin mx-auto"></div>
                  <p className="mt-3">در حال ارسال...</p>
                </div>
              </>
            ) : (
              <>
                {t("Accept & Continue")}
                <span className="sepanta-icon-left-long-arrow"></span>
              </>
            )}
          </button>
        </div>
      </div>
    </form>
  );
}
